export default "__VITE_PUBLIC_ASSET__e52acb5f__"